interface SearchBarProps {
  value: string;
  onChange: (val: string) => void;
}

export function SearchBar({ value, onChange }: SearchBarProps) {
  return (
    <div className="relative w-full max-w-sm">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search by Room Code (e.g. TAMB99)..."
        className="w-full px-4 py-2 text-xs rounded-full bg-slate-950/40 border border-white/10 text-white placeholder-slate-600 focus:outline-none focus:border-purple-500/50 transition-colors shadow-inner"
      />
      <span className="absolute right-3.5 top-2.5 text-xs text-surface-500 select-none">
        🔍
      </span>
    </div>
  );
}
export default SearchBar;
